export default "__VITE_ASSET__CY2yJzkX__"